import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./MealsPop.module.scss";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import {
  useAddMealMutation,
  useUpdateMealMutation,
} from "../../../store/services/mealService";
import { useUpdateEmailTemplateMutation } from "../../../store/services/EmailTemplateService";
import toast from "react-hot-toast";
import CKEditorNew from "../../newCkEditor/ckEditor";

const mealOptions = [
  { value: "ORDER_DELIVERED", label: "Order delivered" },
  { value: "ORDER_RESUMPTION", label: "Order resumption" },
  { value: "OUT_FOR_DELIVERY", label: "Out for delivery" },
  { value: "ORDER_CONFIRMATION", label: "Order confirmation" },
  { value: "ORDER_PAUSE", label: "Order pause" },
  { value: "FORGOT_PASSWORD", label: "Forget password" },
  { value: "WELCOME_EMAIL", label: "Welcome email" },
  { value: "ORDER_CANCEL_REFUND", label: "Order cancel refund" },
  { value: "ORDER_CANCEL_SUPPORT", label: "Order cancel support" },
  {
    value: "ORDER_CANCEL_REFUND_REJECTED",
    label: "Order cancel refund rejected",
  },
  {
    value: "ORDER_CANCEL_REFUND_APPROVED",
    label: "Order cancel refund approved",
  },
  { value: "COOLER_BAG_REFUND", label: "Cooler bag refund" },
  { value: "SUBSCRIBE_EMAIL", label: "Subscribe email" },
  { value: "ORDER_CANCEL_REFUND_STORE_ONLY", label: "Order cancel refund store only" },
  { value: "PRODUCT_REVIEW", label: "Product review" },
  { value: "REPLENISHMENT_REMINDER", label: "Replenishment reminder" },
  { value: "ORDER_CONFIRMATION_STORE_ONLY", label: "Order confirmation store only" },
  { value: "ORDER_DELIVERED_STORE_ONLY", label: "Order delivered store only" },
  { value: "ORDER_DELIVERED_MEAL_PLUS_STORE", label: "Order delivered meal plus store" },
  { value: "OUT_FOR_DELIVERY_MEAL_PLUS_STORE", label: "Out for delivery meal plus store" },
  { value: "OUT_FOR_DELIVERY_STORE_ONLY", label: "Out for delivery store only" },
  { value: "ORDER_CONFIRMATION_MEAL_PLUS_STORE", label: "Order confirmation meal plus store" },
  { value: "ORDER_CANCEL_REFUND_MEAL_PLUS_STORE", label: "Order cancel refund meal plus store" },
  { value: "CART_ABANDONMENT", label: "Cart abandonment" },
];

const EmailTemplatePop = ({ title, modalOpen, setModalOpen, edit }) => {
  console.log("edit", edit);

  const {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched", // Validation mode set to 'onTouched'
    defaultValues: {
      title: edit?.title || "",
      body: edit?.body || "",
      type: edit?.type || [],
    },
  });
  const [selectedMeals, setSelectedMeals] = useState(
    edit?.type
      ? mealOptions.filter((option) => edit.type.includes(option.value))
      : []
  );
  const [isPreview, setIsPerview] = useState(false);
  const [addMeal, { isLoading: isAdding }] = useAddMealMutation();
  // const [updateMeal, { isLoading: isUpdating }] = useUpdateMealMutation();
  const [updateEmailTemplate, { isLoading: isUpdating }] =
    useUpdateEmailTemplateMutation();

  // Handler for react-select
  const handleMealChange = (selectedOptions) => {
    setSelectedMeals(selectedOptions || []);
    const mealValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setValue("type", mealValues); // Update react-hook-form state with an array of values
  };

  // Submit handler
  const onSubmit = async (data) => {
    try {
      if (edit !== null) {
        // Update existing meal
        await updateEmailTemplate({
          mealId: edit._id,
          updatedData: data,
        });
      } else {
        await addMeal(data).unwrap(); // Call deleteMeal and handle success
      }
      setModalOpen(false);
      return toast.success(
        `Email template ${edit ? "updated" : "updated"} successfully`
      );
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle error
    }
  };

  const hideHandler = () => {
    setModalOpen(false);
  };
  return (
    <Modal
      show={modalOpen}
      className={`${styles.MealsPop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
      size="xl"
      enforceFocus={false}
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">{title}</h3>
          <Col lg="12" className="my-2">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Col lg="12" md="12" className="my-2">
                {/* Name Field */}

                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Title
                  </label>
                  <input
                    type="text"
                    placeholder="Enter title"
                    className="form-control"
                    {...register("title", {
                      required: "Please enter title",
                      validate: (value) => {
                        if (/^\s/.test(value)) {
                          return "title cannot start with a space";
                        }
                        // if (/[^a-zA-Z0-9\s]/.test(value)) {
                        //   return "title cannot include special characters or emojis";
                        // }
                        return true;
                      },
                    })}
                  />
                  {errors.title && (
                    <span className="text-danger">{errors.title.message}</span>
                  )}
                </div>

                {/* <button type="button" onClick={() => setIsPerview(!isPreview)} >perview</button> */}

                {/* Description Field */}
                {/* {!isPreview && ( */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Body
                  </label>
                  <textarea
                    rows={7}
                    placeholder="Enter body"
                    className="form-control h-auto"
                    // {...register("description", {
                    //   required: "Please enter description",
                    // })}
                    {...register("body", {
                      required: "Please enter body",
                      validate: (value) => {
                        if (/^\s/.test(value)) {
                          return "body cannot start with a space";
                        }
                        // if (/[^a-zA-Z0-9\s]/.test(value)) {
                        //   return "Description cannot include special characters or emojis";
                        // }
                        return true;
                      },
                    })}
                  ></textarea>
                  {errors.body && (
                    <span className="text-danger">{errors.body.message}</span>
                  )}
                </div>
                {/* )}
                {isPreview && (
                   <div dangerouslySetInnerHTML={{ __html: edit?.body }} />
                )} */}

                {/* Description Field */}
                {/* <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Body
                  </label>

                  <Controller
                    name="body"
                    control={control}
                    rules={{ required: "Please enter body" }}
                    render={({ field }) => (
                      <CKEditorNew
                        field="body"
                        setFieldValue={setValue}
                        value={field.value}
                        error={errors}
                      />
                    )}
                  />

                  {errors.body && (
                    <span className="text-danger">
                      {errors.body.message}
                    </span>
                  )}
                </div> */}

                {/* Meal Type (Select) */}
                {/* <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Types
                  </label>
                  <Select
                    isMulti
                    name="type"
                    options={mealOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={selectedMeals}
                    onChange={handleMealChange}
                    placeholder="Select type"
                  />
                  {errors.type && (
                    <span className="text-danger">
                      {errors.type.message}
                    </span>
                  )}
                </div> */}

                {/* Status Field */}
                {/* <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Status
                  </label>
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10 ps-2 flex-wrap">
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="active"
                        {...register("status", {
                          required: "Status is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Active
                      </label>
                    </li>
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="inactive"
                        {...register("status", {
                          required: "Status is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Inactive
                      </label>
                    </li>
                  </ul>
                  {errors.status && (
                    <span className="text-danger">{errors.status.message}</span>
                  )}
                </div> */}

                {/* Name Field */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Type
                  </label>
                  <Controller
                    name="type"
                    control={control}
                    rules={{
                      required: "Please select a type", // Validation rule
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={mealOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={selectedMeals}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption.value); // Update react-hook-form state
                          setSelectedMeals(selectedOption); // Update local statee
                        }}
                        placeholder="Select type"
                      />
                    )}
                  />
                  {errors.type && (
                    <span className="text-danger">{errors.type.message}</span>
                  )}
                </div>
              </Col>

              {/* Submit & Cancel Buttons */}
              <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-center gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn"
                    type="submit"
                    disabled={isAdding || isUpdating}
                  >
                    Submit
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    type="button"
                    onClick={() => {
                      setModalOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Form>
          </Col>

          {/* <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10">
            <div className="px-2 w-100">
              <Button
                onClick={hideHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
              >
                Cancel
              </Button>
            </div>
            <div className="px-2 w-100">
              <Button
                onClick={confirmHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100"
              >
                {title}
              </Button>
            </div>
          </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EmailTemplatePop;
